import { render, staticRenderFns } from "./FindingTagChips.vue?vue&type=template&id=7235e51e"
import script from "./FindingTagChips.vue?vue&type=script&lang=js"
export * from "./FindingTagChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports